export const DASHBOARD_ANIMATION = {
  unMounted: { opacity: 0 },
  mounted: {
    opacity: 1,
  },
};
